import { render, staticRenderFns } from "./_orderStatus.vue?vue&type=template&id=a3236c14&"
import script from "./_orderStatus.vue?vue&type=script&lang=js&"
export * from "./_orderStatus.vue?vue&type=script&lang=js&"
import style0 from "./_orderStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports